export enum ESystemID {
  // Any errors that happen during installation flow should use this system id.
  IN = "IN",
  // Any unexpected errors or states when we can't define the flow should use this system id.
  UI = "UI",
}

export function makeErrorCode(...parts: string[]): string {
  return ["EOS", ...parts].join("-");
}
